import {getSetting} from '@woocommerce/settings';
import {registerPaymentMethod, registerExpressPaymentMethod} from '@wc-stripe/blocks-express-checkout';
import {ExpressCheckoutContent} from '../express-checkout';
import {PaymentMethod, PaymentMethodLabel} from '@wc-stripe/blocks-components';
import {isCartPage} from '@wc-stripe/blocks-utils';
import ApplePayPreview from "./preview";
import SavedCardComponent from "../saved-card-component";
import './style.scss';

const data = getSetting('stripe_applepay_data');
const activeMethod = {applePay: data.displayRule};

registerPaymentMethod({
    name: data.gatewayId,
    label: <PaymentMethodLabel
        title={data.title}
        paymentMethod={data.gatewayId}
        icons={data.icons}/>,
    ariaLabel: 'Apple Pay',
    activeMethod,
    availabilityKey: 'applePay',
    context: 'checkout',
    sections: data.sections,
    content: (
        <PaymentMethod
            data={data}
            name={data.gatewayId}
            activeMethod={activeMethod}
            isExpress={false}
            content={ExpressCheckoutContent}
        />
    ),
    savedTokenComponent: <SavedCardComponent data={data}/>,
    edit: <ApplePayPreview data={data}/>,
    supports: {
        showSavedCards: data.showSavedCards,
        showSaveOption: false,
        features: data.features
    }
});

registerExpressPaymentMethod({
    name: 'stripe_applepay_express',
    gatewayId: data.gatewayId,
    paymentMethodId: data.gatewayId,
    activeMethod,
    availabilityKey: 'applePay',
    context: () => isCartPage() ? 'cart' : 'express_checkout',
    sections: data.sections,
    content: (
        <ExpressCheckoutContent
            data={data}
            name={'stripe_applepay_express'}
            activeMethod={activeMethod}
        />
    ),
    edit: <ApplePayPreview data={data}/>,
    supports: {
        features: data.features
    }
});